import { render, staticRenderFns } from "./DepartmentUserWindow.vue?vue&type=template&id=1a4de8f5&scoped=true"
import script from "./DepartmentUserWindow.vue?vue&type=script&lang=js"
export * from "./DepartmentUserWindow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUserWindow.vue?vue&type=style&index=0&id=1a4de8f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4de8f5",
  null
  
)

export default component.exports